import { render, staticRenderFns } from "./AccountCompany.vue?vue&type=template&id=4d3997f7"
import script from "./AccountCompany.vue?vue&type=script&lang=js"
export * from "./AccountCompany.vue?vue&type=script&lang=js"
import style0 from "./AccountCompany.vue?vue&type=style&index=0&id=4d3997f7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports